import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SelectItem } from './dropdown';

export const defaultSelectedValue: SelectItem = { label: 'all', value: 'show-all-available-data'};

@Component({
  selector: 'libero-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: false
})

export class DropdownComponent implements OnInit, OnDestroy {
  @Input() public availableList!: SelectItem[];
  @Input() public initialValue?: SelectItem;
  @Input() public selectAllCustomLabel?: string;
  @Input() public displaySelectAllOption? = true;
  @Input() public allPlaceholder?: SelectItem;

  @Input() public itemSelectedControl?: AbstractControl;

  @Output() public itemSelected = new EventEmitter<SelectItem | null>();

  @ViewChild('myInput', {read:ElementRef}) public myInput?: ElementRef<HTMLInputElement>;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: Node): void {
    const clickedInside = this.myInput!.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this._toggled = false;
    }
  }

  private itemSelectedControlSub?: Subscription;

  public allSelectedValue!: SelectItem;

  private _toggled = false;
  public selectedItem!:  SelectItem;

  public get toggled(): boolean {
    return this._toggled;
  }

  public get inputBarLabel(): string {
    return this.selectedItem ? this.selectedItem.label : this.allSelectedValue.label;
  }

  public constructor(
    private translatePipe: TranslatePipe,
  ) { }

  public ngOnInit(): void {
    this.handleSelectAllOption();
    this.handleInitialValue();
    this.initWatcher();
  }

  private initWatcher() {
    if(this.itemSelectedControl) {
      this.itemSelectedControlSub = this.itemSelectedControl.valueChanges.subscribe((value) => {
        const selectedItemRef = this.availableList.find(selection => selection.value === value);

        if(selectedItemRef) {
          this.selectedItem = selectedItemRef;
        } else {
          if(value === null ||
            value.value === defaultSelectedValue.value
          ) {
            this.handleSelectAllOption();
          }
        }
      });
    }
  }

  private handleInitialValue() {
    if (this.initialValue) {
      this.selectedItem = this.initialValue;
    } else {
      this.selectedItem = this.allSelectedValue;
    }
  }

  private handleSelectAllOption(): void {
    this.allSelectedValue = defaultSelectedValue;

    if (this.selectAllCustomLabel) {
      this.allSelectedValue.label = this.selectAllCustomLabel;
    }

    if(!this.displaySelectAllOption) {
      this.selectedItem = this.allPlaceholder!;
      return;
    }

    const defaultSelectRef = this.availableList.find(listValue => listValue.value === defaultSelectedValue.value);

    if (!defaultSelectRef) {
      this.availableList.unshift(this.allSelectedValue);
      this.selectedItem = this.allSelectedValue;
    } else {
      this.selectedItem = defaultSelectRef;
    }
  }

  public toggle(): void {
    this._toggled = !this.toggled;
  }

  public selectItem(selected: SelectItem): void {
    if (this.selectedAll(selected)) {
      this.itemSelected.emit(null);
      this.selectedItem = this.allSelectedValue;
    } else {
      this.itemSelected.emit(selected);
      this.selectedItem = selected;
    }

    if(this.itemSelectedControl) {
      this.itemSelectedControl.patchValue(this.selectedItem);
    }

    this._toggled = false;
  }

  private selectedAll(selected: SelectItem) {
    return this.allSelectedValue.value === selected.value;
  }

  public translateShowAll(item: SelectItem): string {
    if (this.allSelectedValue.value === item.value) {
      return this.translatePipe.transform('dropdown.showAll');
    } else {
      return item.label;
    }
  }

  public ngOnDestroy(): void {
    if (this.itemSelectedControlSub) {
      this.itemSelectedControlSub.unsubscribe();
    }
  }
}
